import { Mobile } from '../core'
import Swiper, { Navigation, Pagination, Scrollbar, Mousewheel, EffectFade, Autoplay, Manipulation } from 'swiper'
import Fancybox from '@fancyapps/fancybox'

Swiper.use([Navigation, Pagination, Scrollbar, Mousewheel, EffectFade, Autoplay, Manipulation]);

$.fn.verticalPageSwiper = function() {
  let self = this
  let container = self.closest('.carousel__container')

  self.measure_title = function() {
    self.find('.layout--portrait_3_car .carousel__title').each(function() {
      $(this).closest('.layout--portrait_3_car').css('--title-height', $(this).height() + 27 + 'px');
    })
    self.find('.layout--landscape_1_car .carousel__title').each(function() {
      $(this).closest('.layout--landscape_1_car').css('--title-height', $(this).height() + 27 + 'px');
    })
  }

  var vswiper = new Swiper(self.get(0), {
    simulateTouch: false,
    speed: 400,
    mousewheel: {
      sensitivity: .333,
    },
    direction: 'vertical',
    navigation: {
      prevEl: container.find('.Vswiper-button-prev').get(0),
      nextEl: container.find('.Vswiper-button-next').get(0),
    },
    scrollbar: {
      el: container.find('.Vswiper-scrollbar').get(0),
      hide: false,
      draggable: false,
    },
    on: {
      activeIndexChange: function (swiper) {
        var active = swiper.activeIndex;
        var activeSlide = $(this.$el).find('.page-section.swiper-slide').eq(active);
        if (activeSlide.find('.layout--full_screen').length > 0) {
          $('body').addClass('--full-screen-slide')
        } else {
          $('body').removeClass('--full-screen-slide')
        }
        if (activeSlide.attr('class').indexOf(" bg-") >= 0) {
          var classes = activeSlide.attr('class').split(' ');
          classes.forEach((class_name) => {
            if (class_name.indexOf('bg-') >= 0) {
              $('body').addClass('frame-' + class_name)
            }
          })
        } else {
          var classes = $('body').attr('class').split(' ')
          classes.forEach((class_name) => {
            if (class_name.indexOf('frame-bg-') >= 0) {
              $('body').removeClass(class_name)
            }
          })
        }
      },
      scroll: function (swiper) {
        console.log('scroll');
      },
      afterInit: function (swiper) {
        let wrapper = $('.Vswiper__wrapper');
        let main = $(this.$el).closest('main');
        main.addClass('--reachBeginning');
        main.find('.Vswiper-button-prev, .Vswiper-button-next').click(function() {
          var current = parseInt(wrapper.attr('data-current'))
          if (main.hasClass('--reachBeginning') && $(this).hasClass('Vswiper-button-prev')) {
            if (main.prev('main').length) {
              wrapper.attr('data-current', current - 1)
            }
          }
          if (main.hasClass('--reachEnd') && $(this).hasClass('Vswiper-button-next')) {
            if (main.next('main').length) {
              $('.Vswiper__wrapper').attr('data-current', current + 1)
            }
          }

          main.removeClass('--reachEnd')
          main.removeClass('--reachBeginning')
          if (swiper.activeIndex == 0) {
            main.addClass('--reachBeginning')
          }
          if (swiper.activeIndex == swiper.slides.length - 1) {
            main.addClass('--reachEnd')
          }
        })
        self.checkScroll = true;
        $(window).bind('mousewheel', function(event) {
          var current = parseInt(wrapper.attr('data-current'))
          var thisSlider = main.prevAll().length + 1;
          if (thisSlider == current) {
            if (self.checkScroll) {
              self.checkScroll = false
              if (event.originalEvent.wheelDelta >= -100) {
                if (main.hasClass('--reachBeginning')) {
                  if (main.prev('main').length) {
                    wrapper.attr('data-current', current - 1)
                  }
                }
              }
              else {
                if (main.hasClass('--reachEnd')) {
                  if (main.next('main').length) {
                    $('.Vswiper__wrapper').attr('data-current', current + 1)
                  }
                }
              }
              main.removeClass('--reachEnd')
              main.removeClass('--reachBeginning')
              if (swiper.activeIndex == 0) {
                main.addClass('--reachBeginning')
              }
              if (swiper.activeIndex == swiper.slides.length - 1) {
                main.addClass('--reachEnd')
              }

              const myTimeout = setTimeout(function(){
                self.checkScroll = true
              }, 300);
            }
          }
        });
      },
    },
  });

  self.getSwiper = function() {
    return vswiper
  }

  self.find('.--small-overlay:not([data-fancybox="fancybox-gallery"]), .--big-overlay:not([data-fancybox="fancybox-gallery"])').click(function() {
    $(this).toggleClass('--hover')
  });

  $('.card-layouts').each(function() {
    if ($(this).find('.card-layouts__content *').length > 0) {
      var classes = '';
      if ($(this).attr("class").match(/bg[\w-]*\b/)) {
        classes += $(this).attr("class").match(/bg[\w-]*\b/);
      }
      if ($(this).hasClass('--big-overlay')) {
        classes += ' --big-overlay';
      }

      if ($(this).hasClass('--small-overlay')) {
        classes += ' --small-overlay';
      }
      $(this).attr('data-caption', '<div class="caption-wrapper ' + classes + '">' + $(this).find('.card-layouts__content').html().trim() + '</div>');
    }
  });

  self.find('a[data-media-type=image]').click(function() {
    if (!$.mlmi.mobile.isMobile) {
      return false;
    }
  })

  self.find('.layout--full_screen').closest('.page-section').addClass('--full-screen')

  return function() {
    $(window).on('load resize orientationchange', self.measure_title)
    return self
  }()
}
